import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import WorksView from '@/views/WorksView.vue'
import VideoDetailView from '@/views/VideoDetailView.vue'
import TasksView from '@/views/TasksView.vue'
import CoursesView from '@/views/CoursesView.vue'
import LoginView from '@/views/LoginView.vue'
import AccountView from '@/views/AccountView.vue'
import AiLoginView from '@/views/AiLoginView.vue'
import LegalView from '@/views/LegalView.vue'
import { authSession, safeReturnPath } from '@/services/auth'

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: (to) => {
    if (to.hash) return { el: to.hash, behavior: 'smooth' }
    return { top: 0 }
  },
  routes: [
    { path: '/', name: 'home', component: HomeView, meta: { title: 'Nova·云枢｜中文 AI 视频创作与培训平台', lang: 'zh-CN' } },
    { path: '/en', name: 'home-en', component: HomeView, props: { locale: 'en' }, meta: { title: 'Nova | AI Video Creation and Training Platform', lang: 'en' } },
    { path: '/works', name: 'works', component: WorksView, meta: { title: '视频作品｜Nova·云枢' } },
    { path: '/video/:id', name: 'video', component: VideoDetailView, meta: { title: '视频详情｜Nova·云枢' } },
    { path: '/tasks', name: 'tasks', component: TasksView, meta: { title: '接单广场｜Nova·云枢' } },
    { path: '/courses', name: 'courses', component: CoursesView, meta: { title: 'AIGC 创作课堂｜Nova·云枢' } },
    { path: '/login', name: 'login', component: LoginView, meta: { title: '账号登录｜Nova·云枢', guestOnly: true } },
    { path: '/register', redirect: (to) => ({ name: 'login', query: to.query }) },
    { path: '/forgot-password', redirect: (to) => ({ name: 'login', query: to.query }) },
    { path: '/auth/wechat/callback', redirect: (to) => ({ name: 'login', query: { ...to.query, wechat: 'callback' } }) },
    { path: '/account', name: 'account', component: AccountView, meta: { title: '我的账号｜Nova·云枢', requiresAuth: true } },
    { path: '/auth/ai', name: 'ai-login', component: AiLoginView, meta: { title: '进入 AI 创作平台｜Nova·云枢', requiresAuth: true } },
    { path: '/share/ai-film', name: 'film-share', component: () => import('@/views/FilmShareView.vue'), meta: { title: '分享成片｜Nova·云枢', requiresAuth: true } },
    { path: '/legal/:type(privacy|agreement|safety)', name: 'legal', component: LegalView, meta: { title: '网站规则｜Nova·云枢' } },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
})

router.beforeEach(async (to) => {
  if (!to.meta.requiresAuth && !to.meta.guestOnly) return true
  await authSession.initialize()
  if (to.meta.requiresAuth && !authSession.isAuthenticated.value) {
    return { name: 'login', query: { redirect: safeReturnPath(to.fullPath) } }
  }
  if (to.meta.guestOnly && authSession.isAuthenticated.value) {
    return safeReturnPath(to.query.redirect)
  }
  return true
})

router.afterEach((to) => {
  document.title = String(to.meta.title ?? 'Nova·云枢')
  document.documentElement.lang = String(to.meta.lang ?? 'zh-CN')
})

export default router
